import { PayloadAction } from "@reduxjs/toolkit";
import { put, select, takeLatest } from "redux-saga/effects";
import { RootState } from "../..";
import { customerLookup, fetchBillerCategories, fetchBillerCategoriesFailed, fetchBillerCategoriesSuccess, fetchBillerInfo, fetchBillerInfoV2, fetchBillerInfoSuccess, fetchBillers, fetchBillersFailed, fetchBillersSuccess, fetchSearchedBillers, payBillProcessTrxn, fetchBillerInfoV2Failure, fetchBillerInfoV2Success } from "../../slices/payBillSlice";
import api from "../../../services/apiService";
import { ENDPOINTS } from "../../../config/endpoints";
import { ToastNotifyError } from "../../../components/ToastNotify";
import { getText } from "../../../helpers/translateHelper";
import { SOME_ERR } from "../../../data/constants";

function* getBillerCategories(action: PayloadAction<any>): Generator {
  try {
    const response: any = yield api.request({
      method: "GET",
      url: ENDPOINTS.PAY_BILL.fetchCategories
    });
    if (!!response?.data?.result?.data?.length && response?.data?.statusCode === 200) {
      yield put(fetchBillerCategoriesSuccess(response.data.result.data));
    } else {
      yield put(fetchBillerCategoriesFailed([]));
      ToastNotifyError(response?.data?.message);
    }
  } catch (error) {
    console.log(error);
  }
}

function* getBillers(action: PayloadAction<any>): Generator {
  let payload = action.payload;
  try {
    const response: any = yield api.request({
      method: "GET",
      url: ENDPOINTS.PAY_BILL.fetchBillers(payload.code)
    });
    if (!!response?.data?.result?.data?.length && response?.data?.statusCode === 200) {
      !!action?.payload?.callback && action.payload.callback(response.data);
      yield put(fetchBillersSuccess(response.data.result.data));
    } else {
      yield put(fetchBillersFailed([]));
      !!action?.payload?.callback && action.payload.callback([]);
      ToastNotifyError(response?.data?.message);
    }
  } catch (error) {
    console.log(error);
  }
}

function* getSearchedBillers(action: PayloadAction<any>): Generator {
  let payload = action.payload;
  try {
    const response: any = yield api.request({
      method: "POST",
      url: ENDPOINTS.PAY_BILL.fetchSearchedBillers,
      data: payload.data,
      hideLoader: payload.hideLoader
    });
    if (response?.data?.statusCode === 200 && response?.data?.result?.data) {
      action?.payload?.callback?.(response.data.result.data);
    } else if (response?.data?.statusCode === 4401) {
      action?.payload?.callback?.([]);
    } else {
      action?.payload?.errorCallback?.();
    }
  } catch (error) {
    action?.payload?.errorCallback?.();
  }
}

function* getBillerInfo(action: PayloadAction<any>): Generator {
  let payload = action.payload;
  try {
    const response: any = yield api.request({
      method: "GET",
      url: ENDPOINTS.PAY_BILL.fetchBillerInfo(payload.code)
    });
    if (response?.data?.statusCode === 200) {
      !!action?.payload?.callback && action.payload.callback(response.data);
      yield put(fetchBillerInfoSuccess(response.data.result.data));
    } else {
      ToastNotifyError(response?.data?.message);
    }
  } catch (error) {
    console.log(error);
  }
}

function* getBillerInfoV2(action: PayloadAction<any>): Generator {
  let payload = action.payload;
  try {
    const response: any = yield api.request({
      method: "POST",
      url: ENDPOINTS.PAY_BILL.fetchBillerInfoV2,
      data: payload.data,
      hideLoader: payload.hideLoader
    });
    if (response?.data?.statusCode === 200) {
      yield put(fetchBillerInfoV2Success(response.data));
      action?.payload?.callback?.(response.data);
    } else {
      yield put(fetchBillerInfoV2Failure(response.data));
      action?.payload?.errorCallback?.(response.data);
      ToastNotifyError(response?.data?.message);
    }
  } catch (error) {
    yield put(fetchBillerInfoV2Failure(error));
    ToastNotifyError(getText(SOME_ERR));
  }
}

function* getCustomerLookup(action: PayloadAction<any>): Generator {
  let payload = action.payload;
  try {
    const response: any = yield api.request({
      method: "POST",
      url: ENDPOINTS.PAY_BILL.customerLookup(payload.code),
      data: payload.dataToSend
    });
    if (response?.data?.statusCode === 200) {
      !!action?.payload?.callback && action.payload.callback(response.data);
      yield put(fetchBillerInfoSuccess(response.data.result.data));
    } else {
      ToastNotifyError(response?.data?.message);
    }
  } catch (error) {
    console.log(error);
  }
}

function* processTrxn(action: PayloadAction<any>): Generator {
  let payload = action.payload;
  const invalidAMPinStatuses = (yield select((state: RootState) => state.config?.basicConfig?.invalidAMPinStatuses)) as number[];
  try {
    const response: any = yield api.request({
      method: "POST",
      url: ENDPOINTS.PAY_BILL.processTrxn,
      data: payload.data
    });
    if (response?.data?.statusCode === 200) {
      !!action?.payload?.successCallback && action.payload.successCallback(response.data);
      yield put(fetchBillerInfoSuccess(response.data.result.data));
    } else if (response && !invalidAMPinStatuses?.includes(response?.data?.statusCode)) {
      action?.payload?.errorPageCallback?.(response?.data);
    } else {
      !!action?.payload?.errorCallback && action.payload.errorCallback(response?.data);
    }
  } catch (error) {
    console.log(error);
  }
}

export default function* root(): Generator {
  yield takeLatest(fetchBillerCategories.type, getBillerCategories);
  yield takeLatest(fetchBillers.type, getBillers);
  yield takeLatest(fetchSearchedBillers.type, getSearchedBillers);
  yield takeLatest(fetchBillerInfo.type, getBillerInfo);
  yield takeLatest(fetchBillerInfoV2.type, getBillerInfoV2);
  yield takeLatest(customerLookup.type, getCustomerLookup);
  yield takeLatest(payBillProcessTrxn.type, processTrxn);
}